import React from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import logo from "../pages/logo.png";

import { useNavigate } from "react-router-dom";
import { msAutoLinks, navigationLinks } from "../routes";
import { loggedInUser } from "../httpService";

export default function MyNavbar() {
  const navigate = useNavigate();
  return (
    <div>
      <Navbar bg="light" expand="lg" data-bs-theme="light">
        <Container>
          <Navbar.Brand href="/">
            <img
              src={logo}
              width="35"
              height="30"
              className="d-inline-block align-top"
              alt="Jamb Logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {navigationLinks.map((c, i) => (
                <Nav.Link key={i} onClick={() => navigate(c.path)}>
                  {c.name}
                </Nav.Link>
              ))}
            </Nav>
            <Nav className="ms-auto">
              {loggedInUser && (
                <Navbar.Text>{loggedInUser.firstName}</Navbar.Text>
              )}
              {msAutoLinks.map((c, i) => (
                <Nav.Link
                  key={i}
                  onClick={() => {
                    {
                      c.type === "button" && c.action();

                      navigate(c.path);
                    }
                  }}
                >
                  {c.name}
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}
